var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_38_3710)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 0C2.23853 0 0 2.23853 0 5C0 7.76147 2.23853 10 5 10C7.76147 10 10 7.76147 10 5C10 2.23853 7.76147 0 5 0ZM6.98485 6.15238C7.21472 6.38225 7.21472 6.75541 6.98485 6.98528C6.8697 7.10043 6.71905 7.15758 6.5684 7.15758C6.41775 7.15758 6.2671 7.1 6.15195 6.98528L4.99957 5.8329L3.84719 6.98528C3.73203 7.10043 3.58139 7.15758 3.43074 7.15758C3.28009 7.15758 3.12944 7.1 3.01429 6.98528C2.78442 6.75541 2.78442 6.38225 3.01429 6.15238L4.16667 5L3.01429 3.84762C2.78442 3.61775 2.78442 3.24459 3.01429 3.01472C3.24416 2.78485 3.61732 2.78485 3.84719 3.01472L4.99957 4.1671L6.15195 3.01472C6.38182 2.78485 6.75498 2.78485 6.98485 3.01472C7.21472 3.24459 7.21472 3.61775 6.98485 3.84762L5.83247 5L6.98485 6.15238Z",
    fill: "#D91219"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_3710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassCancel);
export default __webpack_public_path__ + "static/media/passCancel.0fea9d7ec6f65630c7052128ba8c14cb.svg";
export { ForwardRef as ReactComponent };